<template>
  <div style="background-color: #edf4fc;">
    <div style="overflow: hidden;">

      <div style="margin-bottom: 0.1rem;">
        <div style="border: 1px dashed rgb(223, 221, 221);margin: 0.1rem;">
          <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据学校名称搜索国际项目信息：</div>
          <div class="content-input">
            <el-input v-model="schoolName" placeholder="请输入学校名称" class="content-input-el" clearable @keyup.enter.native="schoolFind()"></el-input>
            <el-button type="primary" style="height: 0.34rem; margin-left: 0.2rem" @click="schoolFind()">搜索</el-button>
          </div>
        </div>
        <el-row>
          <el-col :span="6" v-for="item in Nations" :key="item.id" style="padding: 0.15rem;">
            <a :href="item.link" target="_blank">
              <el-image :src="item.picture" style="height: 1.5rem;width: 100%;border-radius: 5px;">
                <div slot="error" v-loading="loading"></div>
              </el-image>
              <p style="text-align: left;font-size: 18px;font-weight: 700;margin: 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.name }}</p>
              <p style="text-align: left;font-size: 18px;font-weight: 700;margin: 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.major }}</p>
            </a>
          </el-col>
        </el-row>
        <el-pagination :current-page="currentPage" :page-size="pageSize" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
      </div>

    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { selectNation, selectNationName } from '@/api/nationAPI'

export default {
  name: 'Nation',
  data() {
    return {
      Nations: [],
      schoolName: '',
      loading: true,
      currentPage: 1,
      pageSize: 12,
      total: 1
    }
  },
  created() {
    this.selectNations()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async schoolFind() {
      this.currentPage = 1
      const { data: res } = await selectNationName(this.schoolName, this.currentPage, this.pageSize)
      this.Nations = res.data[2]
      this.total = res.data[0]
    },
    async selectNations() {
      const { data: res } = await selectNation(this.currentPage, this.pageSize)
      this.Nations = res.data[2]
      this.total = res.data[0]
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      const { data: res } = await selectNation(this.currentPage, this.pageSize)
      this.Nations = res.data[2]
      this.total = res.data[0]
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.content-input {
  margin: 0.1rem;
  .content-input-el {
    width: 3rem;
  }
}
.Nation-col {
  margin: 0.15rem;
}
.el-button {
  padding: 0.08rem 0.08rem;
}
.el-pagination {
  text-align: center;
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
</style>
